var _defs, _path, _circle, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1014",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1015"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1016"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 40 40",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M18.62 10.88a8.39 8.39 0 0 0-5.77 4.18 1 1 0 1 0 1.75 1 6.39 6.39 0 1 1 10.89 6.68 6.4 6.4 0 0 1-10.93-.57 1 1 0 0 0-1.77.94 8.36 8.36 0 0 0 7.38 4.44 8.85 8.85 0 0 0 1.61-.15 8.4 8.4 0 0 0-3.16-16.49Z",
    className: "color231f20 svgShape"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.26,
    cy: 10.1,
    r: 1.81,
    fill: "#ffffff",
    className: "color231f20 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M28.14 2.46H12.25a8.7 8.7 0 0 0-8.69 8.69V27a8.7 8.7 0 0 0 8.69 8.7h15.89a8.7 8.7 0 0 0 8.69-8.7V11.15a8.7 8.7 0 0 0-8.69-8.69ZM34.83 27a6.7 6.7 0 0 1-6.69 6.7H12.25A6.7 6.7 0 0 1 5.56 27V11.15a6.7 6.7 0 0 1 6.69-6.69h15.89a6.7 6.7 0 0 1 6.69 6.69Z",
    className: "color231f20 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M13.63 19a1 1 0 0 0-1.2-.81 1 1 0 1 0 .39 2 1 1 0 0 0 .81-1.19Z",
    className: "color231f20 svgShape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f433bd2f10ea8cf414126145285687d9.svg";
export { ForwardRef as ReactComponent };